import { render, staticRenderFns } from "./OrderExchangeRecive.vue?vue&type=template&id=512ff124&scoped=true"
import script from "./OrderExchangeRecive.vue?vue&type=script&lang=js"
export * from "./OrderExchangeRecive.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeRecive.vue?vue&type=style&index=0&id=512ff124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ff124",
  null
  
)

export default component.exports